import { trim } from '@/utils/utils';
import React, { useState } from 'react'
import { Input, Icon, Button } from 'tea-component'
import { useIntl } from "umi";

import './index.scss'


const CustomizedPanel = (props) => {
  const {
    placeholder,
    validate,
    onConfirm,
    onBack
  } = props
  const { formatMessage } = useIntl();

  const [value, setValue] = useState("");
  const errorMessage = validate(value);
  return (
    <>
      <div className='dtb-db-tracking-day__input-box'>
        <Input
          value={value}
          placeholder={placeholder}
          onChange={(value) => setValue(value)}
        />
        {value?.length > 0 && <Icon type='dismiss' onClick={() => { setValue("") }} />}
      </div>
      {
        errorMessage ? (
          <div className='dtb-db-tracking-day--error'>
            <span className='dtb-db-tracking-day--error-text' dangerouslySetInnerHTML={{ __html: errorMessage }} />
          </div>
        ) : ''
      }
      <div className='dtb-db-tracking-day__btn-group'>
        <Button
          className='dbd-event-option-btn-confirm'
          disabled={errorMessage || !trim(value)}
          type='primary'
          onClick={() => { onConfirm(value) }}
        >
          {formatMessage({ id: "common_confirm" })}
        </Button>
        <Button
          className='dbd-event-option-btn-cancel'
          type='weak'
          onClick={onBack}>
          {formatMessage({ id: "common_back" })}
        </Button>
      </div>
    </>
  )
}

export default CustomizedPanel
